var cancel_confirm_styles = {
  input: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-start",
    // gap: "6px",
    alignSelf: "stretch",
    paddingTop: 20
  },
  input_title_container: {
    display: "flex",
    alignItems: "flex-end" as const,
    // gap: "2px",
  },
  input_title: {
    color: "var(--Gray---800, #4F5467)",
    fontFamily: "Montserrat",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    margin: 0,
    padding: 0,
    paddingBottom: 10,
  },
  field_and_helper_text: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    // gap: "4px",
    alignSelf: "stretch",
  },
  field: {
    display: "flex",
    padding: "12px 8px 12px 12px",
    justifyContent: "space-between" as const,
    alignItems: "center" as const,
    alignSelf: "stretch" as const,
    borderRadius: "4px",
    border: "1px solid var(--Gray---200, #D3D8DE)",
  },
};

export default cancel_confirm_styles;